<template>
  <div>
    <template v-for="(item, index) in options">
      <template v-if="values.includes(parseInt(item.dictKey))">
        <Button :type="item.styleClass" size="small" :key="item.dictKey" :index="index">
          <span>{{ item.dictValue }}</span>
        </Button>
      </template>
    </template>
  </div>
</template>
<script>
export default {
  name: 'DictTag',
  props: {
    options: {
      type: Array,
      default: null
    },
    value: [Number, String, Array]
  },
  computed: {
    values() {
      if (this.value !== null && typeof this.value !== 'undefined') {
        return Array.isArray(this.value) ? this.value : [this.value]
      } else {
        return []
      }
    }
  }
}
</script>
<style scoped>
.el-tag + .el-tag {
  margin-left: 10px;
}
</style>
